export enum LogLevel {
    none,
    info,
    error,
    warn,
    debug,
    all
}
